import React from 'react';
import DischargePatientList from './DischargePatientList';

const DischargeUnassignedPatients: React.FC = () => <DischargePatientList ownershipFilter="UNASSIGNED" />;

export default DischargeUnassignedPatients;
